import $ from 'jquery';
import UIkit from 'uikit';
window.addEventListener('px-ready',function(){
    $('body').attr('scrollb4',0);
    $('body').attr('menuDisplace',0);
    if ($('.ancr-pos-top').length) {
        var notice_height = $('.ancr-pos-top').height();
        $('.navbar').css('transform','translate(0px, '+notice_height+'px)');
        $('.navbar').css('top','0px');
    }
    $(window).on('resize',function(){
        if ($('.ancr-pos-top').length) {
            var notice_height = $('.ancr-pos-top').height();
            $('.navbar').css('transform','translate(0px, '+notice_height+'px)');
            $('.navbar').css('top','0px');
        }
    });
    $(window).on('scroll',function(){
        //console.log('y')
        var scrollb4 = parseInt($('body').attr('scrollb4-nav'));
        var scroll = $(window).scrollTop().valueOf();
        var menuDisplace = parseInt($('body').attr('menuDisplace'));
        var menuH = $('header.navbar').outerHeight();
        //console.log(menuH);
        //var quickmenuH = $('.px-quickmenu').outerHeight();
        var quickmenuH = 0;
        var menuMaxH = menuH + quickmenuH + 150;
        //console.log(menuH);
        var newScrollLoc = scroll-scrollb4;
        menuDisplace += parseInt(newScrollLoc);
        //console.log(scroll + ' ' + scrollb4 + ' ' + newScrollLoc);
        if(menuDisplace < 0){menuDisplace = 0;}
        if(menuDisplace > menuMaxH){menuDisplace = menuMaxH;}
        if(isNaN(menuDisplace)){menuDisplace=0;}
        $('body').attr('menuDisplace',menuDisplace);
        menuDisplace -= quickmenuH;
        if(menuDisplace < 0){menuDisplace = 0;}
        /*if(scroll < menuMaxH){
            menuDisplace = 0;
        }*/
        //console.log(menuDisplace);
        $('body').attr('scrollb4-nav',scroll);
        $('.navbar').css('top','-'+menuDisplace+'px');
        if(scroll>100){
            $('body,#swup').addClass('is-scrolled');
        }else{
            $('body,#swup').removeClass('is-scrolled');
        }
    }).trigger('scroll');

    if ( $( "#offcanvasmenu" ).length ) {
        console.log('offcanvas hide');
        UIkit.offcanvas('#offcanvasmenu').hide();
    }

    /*var timer = 0;
    $('.uk-offcanvas-bar .animlinks a').each(function(){
        $(this).css('transition-delay',timer+'ms');
        timer += 50;
    })*/
})